import {tongjiToken} from './config';
import loadScript from './loadScript';

(function (global, src, hmc) {
    // 记录 hmCircular 的 namespace
    global.holmesCircularObject = hmc;
    // 初始化 _hmc 对象
    global[hmc] = global[hmc] || function (...args) {
        (global[hmc].q = global[hmc].q || []).push(args);
    };
    // 加载 JS SDK
    loadScript(src);
})(window, `https://circular.baidu.com/circular.js?si=${tongjiToken}`, '_hmc');